

import React, { useEffect, useState } from 'react';
import NewTimesheetPanel from '../../consultants-vision-admin/timesheet/NewTimesheetPanel';
import Timesheet from '../../consultants-vision-admin/timesheet/Timesheet';
import { Toaster } from '@/components/organisms/feedback/toaster';
import PrintErrorMessage from "@/components/organisms/feedback/PrintErrorMessage";
import InViewComponent from '@/components/organisms/InViewComponent';
import { useTimesheets } from '@/services/consultant-services/query/useTimesheets';
import ReplayRoundedIcon from '@mui/icons-material/ReplayRounded';
import { Button } from "@/components/molecules/buttons/button";
import PrintEmptyDataMessage from '@/components/molecules/PrintEmptyDataMessage';
import { Label } from '@/components/atoms/texts/label';
import WarningRoundedIcon from '@mui/icons-material/WarningRounded';
export default function TimesheetTabUser() {
    const [lastSlice, setLastSlice] = useState(1);
    const [timesheetsCopy, setTimesheetsCopy] = useState([]);
    const { loading, error, data: timesheets, refetch } = useTimesheets(1);

    const refetchFromScratch = (n = 1) => {
        console.log("debug refetchFromScratch")

        setLastSlice(n);
        setTimesheetsCopy([]);
        // pour éviter que refetchFromScratch vide les données
        refetch(n).then((res) => {
            console.log("debug res = ", res.loading, res.error, res.data);
            if (res.data.timesheets.timesheets) {
                setTimesheetsCopy(res.data.timesheets.timesheets);
            }
        });
    };

    const fetchNewSlice = () => {
        if (!loading && timesheetsCopy.length > 0 && timesheets?.hasNext) {
            setLastSlice((prevSlice) => prevSlice + 1);
        }
    };

    useEffect(() => {
        console.log("debug timesheets", timesheets, "timesheetsCopy", timesheetsCopy, timesheetsCopy.length === 0, !error, !loading, !error && !loading && timesheetsCopy.length === 0, "lastSlice", lastSlice)
        if (!loading && timesheets) {
            if (lastSlice == 1) {
                setTimesheetsCopy(() => [
                    ...timesheets?.timesheets
                ]);
            } else {
                setTimesheetsCopy((prevTimesheets) => [
                    ...prevTimesheets,
                    ...timesheets?.timesheets
                ]);
            }

        }
    }, [timesheets]);

    return (
        <div className="flex flex-col items-end gap-secondDegree overflow-auto pb-secondDegree px-1">
            {/* START WARNING BOOND MANAGER  */}
            {/* import WarningRoundedIcon from '@mui/icons-material/WarningRounded'; */}
            {window.ENV.BOOND_MANAGER_ACTIVE_MODE && <div className="bg-warning w-full p-1 items-center justify-center flex gap-betweenText rounded-sm">
                <WarningRoundedIcon className="mr-1"/>
                <Label message="boondManager.timesheet"/>
                <a target="blank"  href={window.ENV.BOOND_MANAGER_URL + ``}><Label className="underline cursor-pointer" message="boondManager.linkBM"></Label></a>
            </div>}
            {/* END WARNING BOOND MANAGER */}
            <div className="flex gap-secondDegree">
                <Toaster />
                <Button style="ghost" disabled={loading} showLeftIcon leftIcon={<ReplayRoundedIcon />} onClick={() => refetchFromScratch()} showText={false} sizePadding={"firstDegree"} />
                {!window.ENV.BOOND_MANAGER_ACTIVE_MODE && <NewTimesheetPanel global={false} refetchTimesheets={refetchFromScratch} newTimesheetButton />}
            </div>

            {loading && <div className="w-full flex justify-center"><span className="loader" /></div>}
            {error && <PrintErrorMessage error={error} />}
            {(!error && !loading && timesheetsCopy.length > 0) && timesheetsCopy.map((item, index) => (
                <Timesheet key={index} data={item} dataOwner refetchTimesheets={refetchFromScratch} />
            ))}
            {(!error && !loading && timesheetsCopy.length === 0) && <PrintEmptyDataMessage message="error.emptyDataTimesheet" />}

            <InViewComponent inView={fetchNewSlice} />
        </div>
    );
}